/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Outlook_Ingest_Approval_TitleInputs */

const es_components_outlook_ingest_approval_title = /** @type {(inputs: Components_Outlook_Ingest_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar ingesta de adjuntos`)
};

const en_components_outlook_ingest_approval_title = /** @type {(inputs: Components_Outlook_Ingest_Approval_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm attachment ingestion`)
};

/**
* | output |
* | --- |
* | "Confirm attachment ingestion" |
*
* @param {Components_Outlook_Ingest_Approval_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_outlook_ingest_approval_title = /** @type {((inputs?: Components_Outlook_Ingest_Approval_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Outlook_Ingest_Approval_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_outlook_ingest_approval_title(inputs)
	return en_components_outlook_ingest_approval_title(inputs)
});
export { components_outlook_ingest_approval_title as "components.outlook_ingest_approval.title" }